import { useId } from 'react'
import { getDateString } from '../../../../assets/utils/format'
import type { Hit } from 'instantsearch.js'
import { _x } from '@wordpress/i18n'
import ServiceListCard from './ListCard'

function ServiceListGroup(props: {
  timestamp: number
  items: Hit[]
}) {
  const formattedDate = getDateString(
    new Date(props.timestamp),
    _x('l, dS F Y', 'Celebration List Date', 'icf')
  )

  const titleId = useId()

  return (
    <ul className="services-list-group">
      <p id={titleId} className="title h3">
        {formattedDate}
      </p>
      <ul aria-labelledby={titleId} className="list">
        {props.items.map((item) => (
          <li key={item.objectID} className="d-block">
            <ServiceListCard hit={item} />
          </li>
        ))}
      </ul>
    </ul>
  )
}

export default ServiceListGroup
